export default class AbstractFilter {
    constructor() {
        this.appInitial = null
        this.filter = {};
    }

    pagination() {
        let self = this;
        $('.account-page').on('click', '.tab_area .pager li:not(.disabled)', function (e) {
            e.preventDefault();
            let params = {page: $(this).attr('data-p')};
            self.appInitial.getFilterData(params);
        });
    }

    filters() {
        let self = this;
        $('.account-page').on('click', '.xhr-filter li:not(.active)', function (e) {
            e.preventDefault();
            let filterValue = $(this).attr('data-filter').split(':');
            self.filter = {
                page: 1,
                filter_name: filterValue[0],
                filter_value: filterValue[1]
            }

            self.appInitial.getFilterData(self.filter);
        });
    }

    preloader(status) {
        let $owP = $('.overlay_page');
        if(status === true) {
            $owP.prepend('<img style="position: absolute;left: 50%;top:50%;transform: translate(-50%, -50%)" src="/assets/images/svg/preloader.svg">');
            $owP.fadeIn(200);
        } else {
            $owP.fadeOut(200, function () {
                $owP.find('img').remove();
            });
        }
    }

    /**
     *
     * @param confName
     */
    confirmDelete(confName) {
        $('#deleteModal .btn').on('click', function (e){
            e.preventDefault();

            $(document).trigger(confName);
            $('#deleteModal .close').trigger('click');
        });
    }
}
